<div  (mouseenter)="this.dotComService.DisplaySubMenu('')">
    <p>resources works!</p>
</div>